import React, { useEffect, useState } from "react";
import "./ExistingHutchForm.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useProcessContext } from "../../../context/ProcessContext";
import { BallTriangle } from "react-loader-spinner";
import BASE_URL, { API_KEY, PAYLOAD_SECRET } from "../../../../config";

const ChooseRepository = () => {
    const { centerAlert, userData, encryptData } = useProcessContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const repoData = location.state?.repoData || [];
    const temp = location.state?.code || "";
    const temp1 = location.state?.temp || "";
    const [selectedRepo, setSelectedRepo] = useState("");
    const [branches, setBranches] = useState([]);
    const [owner, setOwner] = useState("");

    const [configureData, setConfigureData] = useState({
        userId: userData.userid,
        repoName: "",
        // filepath: "/home/o2b-12/workspace/odoo/odoofor_react/githubaccess/temp/o2b_process_modular",
        filepath: "/home/o2b/app_checkout/module/o2b_process_modular",
        module_name: "o2b_process_modular",
        branch: "",
    });

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        setConfigureData((prevState) => ({
            ...prevState,
            [name]: type === "checkbox" ? checked : value?.trim(),
        }));
    };

    // Handle repository selection
    const handleRepoChange = (e) => {
        const selectedFullName = e.target.value;
        setSelectedRepo(selectedFullName);

        // Find selected repo data
        const repo = repoData.find(repo => repo.full_name === selectedFullName);

        // Update branches dropdown
        setBranches(repo ? repo.branches : []);
        setOwner(repo ? repo.owner : "")

        // Update configureData with repo name
        setConfigureData((prevState) => ({
            ...prevState,
            repoName: repo ? repo.repo_name : "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${BASE_URL}/odoosh/upload-data`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    owner: owner,
                    repo: configureData.repoName,
                    branch: configureData.branch,
                    filepath: configureData.filepath,
                    module_name: configureData.module_name,
                    temp: temp,
                    temp1: temp1,
                    user_id: userData.userid,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("response data in sub ===========", data)
                setLoading(false);
                centerAlert("success", data.message);
                navigate("/configuration/odoo-sh/validate");
            } else {
                const data = await response.json();
                setLoading(false);
                centerAlert("error", data.message);
                console.error("Error creating data:", data);
            }
        } catch (error) {
            setLoading(false);
            centerAlert("error", error);
            console.error("Network error:", error);
        }
    };

    // console.log("userData:::::::: ", userData);
    console.log("configureData::: ", configureData);
    // console.log("key::: ", API_KEY);
    // setLoading(true)
    return (
        <div
            className="d-flex flex-column align-items-center"
            style={{ width: "100%", height: "100%", backgroundColor: "white" }}
        >
            {loading && (
                <div
                    className="progress_bar_checkin"
                    style={{ width: "350px", height: "250px", top: "40%" }}
                >
                    {/* Loading */}
                    <h3>Processing...</h3>
                    {/* <ProgressBar progress={progress} /> */}
                    <BallTriangle
                        height={100}
                        width={100}
                        radius={5}
                        color="#1a7e8f"
                        ariaLabel="ball-triangle-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                </div>
            )}
            <div className="configure_page_container">
                <form className="configure_page_form" onSubmit={handleSubmit}>
                    <h2>Choose working Repository</h2>
                    <div
                        className="mb-3 d-none justify-content-start align-items-center gap-3"
                        style={{ width: "100%" }}
                    >
                        <label htmlFor="exampleInputUserId1" className="form-label">
                            User Id
                        </label>
                        <input
                            type="text"
                            name="userId"
                            value={configureData.userId}
                            placeholder="enter user id"
                            className="form-control"
                            id="exampleInputUserId1"
                            onChange={handleInputChange}
                            readOnly
                        />
                    </div>

                    <div className="mb-3 d-flex justify-content-start align-items-center gap-3" style={{ width: "100%" }}>
                        <label className="form-label">Choose Repository</label>
                        <select
                            className="form-select configure_page_select"
                            name="repository"
                            value={selectedRepo}
                            onChange={handleRepoChange}
                            required
                        >
                            <option value="" disabled>Choose Repo</option>
                            {repoData.map((repo, index) => (
                                <option key={index} value={repo.full_name}>
                                    {repo.full_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div
                        className="mb-3 d-flex justify-content-start align-items-center gap-3"
                        style={{ width: "100%" }}
                    >
                        <label htmlFor="exampleInputConfigName1" className="form-label">
                            Repo Name
                        </label>
                        <input
                            type="text"
                            name="repoName"
                            className="form-control"
                            value={configureData.repoName}
                            placeholder="enter repo name"
                            id="exampleInputConfigName1"
                            onChange={handleInputChange}
                            disabled
                        />
                    </div>

                    <div className="mb-3 d-flex justify-content-start align-items-center gap-3" style={{ width: "100%" }}>
                        <label className="form-label">Branch Name</label>
                        <select
                            className="form-select configure_page_select"
                            name="branch"
                            value={configureData.branch}
                            onChange={handleInputChange}
                            required
                            disabled={!selectedRepo}
                        >
                            <option value="" disabled>Choose branch</option>
                            {branches.length > 0 ? (
                                branches.map((branch, index) => (
                                    <option key={index} value={branch}>
                                        {branch}
                                    </option>
                                ))
                            ) : (
                                <option value="" disabled>No branches available</option>
                            )}
                        </select>
                    </div>

                    <div
                        className="mb-3 d-flex justify-content-start align-items-center gap-3"
                        style={{ width: "100%" }}
                    >
                        <label htmlFor="exampleInputConfigName1" className="form-label">
                            Filepath
                        </label>
                        <input
                            type="text"
                            name="filepath"
                            className="form-control"
                            value={configureData.filepath}
                            placeholder="enter filepath"
                            id="exampleInputConfigName1"
                            onChange={handleInputChange}
                        // required

                        />
                    </div>

                    <div
                        className="mb-3 d-flex justify-content-start align-items-center gap-3"
                        style={{ width: "100%" }}
                    >
                        <label htmlFor="exampleInputParameter1" className="form-label">
                            Module name
                        </label>
                        <input
                            type="text"
                            name="module_name"
                            value={configureData.module_name}
                            placeholder="enter your url"
                            className="form-control"
                            id="exampleInputParameter1"
                            onChange={handleInputChange}
                        // required
                        />
                    </div>


                    <div className="d-flex justify-content-center align-items-center gap-3">
                        <Link to={"/dashboard/configurations/hutch"}>
                            <button className="btn btn-secondary">Discard</button>
                        </Link>
                        <button
                            type="submit"
                            className="btn my-3"
                            style={{ backgroundColor: "#1a7e8f", color: "white" }}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChooseRepository;